import { render } from "./notFound.vue?vue&type=template&id=54f1d66e&scoped=true"
const script = {}

import "./notFound.vue?vue&type=style&index=0&id=54f1d66e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f1d66e"]])

export default __exports__